import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import html2canvas from "html2canvas";
import { Workbook } from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';
import jsPDF from "jspdf";
import * as moment from "moment";

@Component({
    selector: "app-warehouse-volumes",
    templateUrl: "./warehouse-volumes.component.html",
    styleUrls: ["./warehouse-volumes.component.css"],
})
export class WarehouseVolumesComponent implements OnInit {
    @ViewChild('reports', { static: false }) reports: ElementRef;
    @ViewChild('inbound', { static: false }) inbound: ElementRef;
    @ViewChild('outbound', { static: false }) outbound: ElementRef;
    statusArray = [];
    transactionArray = [];
    parentWarehousesArray = [];
    warehousesArray = [];
    warehouseIbPieChart: any;
    warehouseObPieChart: any;
    today = Date.now();
    selected;
    restData: any;
    dashboard: any = {};
    userRole: string;
    isInit: boolean;
    excelDisable: boolean;
    pdfDisable: boolean;
    inboundVolumeCount:number=0;
    outboundVolumeCount:number=0;
    headers = new HttpHeaders();
    dateType :any
    dateTypeList = [
        {label : 'Custom Range' ,value: 'Custom Range'},
        {label : 'Last 30 Days' ,value: 'Last 30 Days'},
        {label : 'Last 7 Days' ,value: 'Last 7 Days'},
        {label : 'Today' ,value: 'Today'},
        {label : 'Yesterday' ,value: 'Yesterday'}
    ]
      alwaysShowCalendars: boolean;
      ranges: any = {
            'Today': [ moment().startOf('day'), moment().endOf('day') ],
            'Yesterday': [ moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
            'Last 7 Days': [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
            'Last 30 Days': [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
            'This Month': [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month').startOf('day'),
              moment().subtract(1, 'month').endOf('month').endOf('day')      
            ]
          };
    
    constructor(
        public localstorage: LocalStorageService,
        public session: SessionStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        private service: MyserviceService
    ) {
        this.headers = this.headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
    }

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.setToDefault();
    }

    generate() {
        this.inboundVolumeCount=0;
        this.outboundVolumeCount=0;
        this.dashboard.fromDate = this.datepipe.transform(
            this.selected.startDate,
            "MM/dd/yyyy HH:mm"
        );
        this.dashboard.toDate = this.datepipe.transform(
            this.selected.endDate,
            "MM/dd/yyyy HH:mm"
        );
        let reqBody={...this.dashboard};
        reqBody.parentWarehouse=this.service.multiSelectValue(this.parentWarehousesArray,this.dashboard.parentWarehouse);
        reqBody.warehouse=this.service.multiSelectValue(this.warehousesArray,this.dashboard.warehouse);
        this.http
            .post(
                environment.apiUrl + "/dashboards/warehouseVolumes",
                reqBody,
                { headers: this.headers }
            )
            .subscribe((data: any) => {
                this.isInit=true;
                this.restData = data;
                let ibWarehouses = [];
                let obWarehouses = [];
                let ibValues = [];
                let obValues = [];
                let ibColors = [];
                let obColors = [];

                this.restData.inbound.forEach((record: any) => {
                    ibWarehouses.push(record.name);
                    ibValues.push(record.count);
                    ibColors.push(this.getRandomColor());
                    //to get the count of inbound volumes
                    this.inboundVolumeCount += parseInt(record.count);
                });
                this.restData.outbound.forEach((record: any) => {
                    obWarehouses.push(record.name);
                    obValues.push(record.count);
                    obColors.push(this.getRandomColor());
                    //to get the count of outbound volumes
                    this.outboundVolumeCount += parseInt(record.count);
                });
                this.warehouseIbPieChart = {
                    labels: ibWarehouses,
                    datasets: [
                        {
                            data: ibValues,
                            backgroundColor: ibColors,
                        },
                    ],
                };

                this.warehouseObPieChart = {
                    labels: obWarehouses,
                    datasets: [
                        {
                            data: obValues,
                            backgroundColor: obColors,
                        },
                    ],
                };              
            });
    }

    getRandomColor() {
        var color = Math.floor(0x1000000 * Math.random()).toString(16);
        return "#" + ("000000" + color).slice(-6);
    }

    getWarehousesForWms(parentWarehouse) {
        this.dashboard.warehouse=[];
        this.warehousesArray = this.service.getWarehouses(
            this.localstorage.retrieve("token"),
            "LIVE",
            this.service.multiSelectValue(this.parentWarehousesArray,parentWarehouse)
        );
    }

    setToDefault() {
        this.isInit=false;
        this.restData = "";
        let today = this.service.getDateByTZ();
        this.selected = {
            startDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                0,
                0,
                0
            ),
            endDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                23,
                59,
                0
            ),
        };
        this.statusArray = this.service.getStatus();
        this.transactionArray = this.service.getDocumentTypes(
            this.localstorage.retrieve("token"),
            "M",
            "LIVE"
        );
        this.parentWarehousesArray = this.service.getParentWarehouses(
            this.localstorage.retrieve("token"),
            "M",
            "LIVE"
        );
        this.dashboard.parentWarehouse = [];
        this.getWarehousesForWms([]);
        this.dashboard.warehouse = [];
        this.dashboard.docType = "-1";
        this.dashboard.status = "-1";
    }
    exportToExcel() {
        this.excelDisable=true;
        this.dashboard.flag = "L";
        this.dashboard.downloadType = "excel";
        let reqBody={...this.dashboard};
        reqBody.parentWarehouse=this.service.multiSelectValue(this.parentWarehousesArray,this.dashboard.parentWarehouse);
        reqBody.warehouse=this.service.multiSelectValue(this.warehousesArray,this.dashboard.warehouse);
        this.http
            .post(environment.apiUrl + "/dashboards/downloadWarehouseVolumes", reqBody, {
                headers: this.headers,
            })
            .subscribe(
                (response: any) => {
                    html2canvas(this.reports.nativeElement).then(canvas => {
                        var date = this.service.getDateByTZ()
                        const img = canvas.toDataURL();
                        let workbook = new Workbook();
                        let worksheet = workbook.addWorksheet('Reports');
                        //For chart heading
                        worksheet.mergeCells('F1:N3');
                        worksheet.getCell('F1').value = `Warehouse Volumes Pie Reports on : ${this.datepipe.transform(date, "short","+0000")}`
                        worksheet.getCell('F1').font = { size: 15, bold: true }
                        worksheet.getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for grid heading
                        worksheet.mergeCells('F25:N27');
                        worksheet.getCell('F25').value = `Warehouse Inbound and Outbound Reports`
                        worksheet.getCell('F25').font = { size: 15, bold: true }
                        worksheet.getCell('F25').alignment = { vertical: 'middle', horizontal: 'center' }
                        let chartImage = workbook.addImage({
                            base64: img,
                            extension: 'png',
                        });
                        worksheet.addImage(chartImage, 'C5:Q22');
                        worksheet.mergeCells('D29:H30');
                        worksheet.getCell('D29').value = "Inbound Reports"
                        worksheet.getCell('D29').font = { size: 13, bold: true }
                        worksheet.getCell('D29').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for inbound header
                        worksheet.mergeCells('M29:Q30');
                        worksheet.getCell('M29').value = "Outbound Reports"
                        worksheet.getCell('M29').font = { size: 13, bold: true }
                        worksheet.getCell('M29').alignment = { vertical: 'middle', horizontal: 'center' }
                        //for inboound table header
                        worksheet.getCell('C32').value = 'Warehouse Name'
                        worksheet.mergeCells('C32:F33')
                        worksheet.getCell('C32').alignment = { horizontal: 'center' }
                        worksheet.getCell('C32').font = { bold: true }
                        worksheet.getCell('G32').value = 'Inbound Doc Count'
                        worksheet.mergeCells('G32:I33')
                        worksheet.getCell('G32').alignment = { horizontal: 'center' }
                        worksheet.getCell('G32').font = { bold: true }
                        //for outbound table header
                        worksheet.getCell('L32').value = 'Warehouse Name'
                        worksheet.mergeCells('L32:O33')
                        worksheet.getCell('L32').alignment = { horizontal: 'center' }
                        worksheet.getCell('L32').font = { bold: true }
                        worksheet.getCell('P32').value = 'Outbound Doc Count'
                        worksheet.mergeCells('P32:R33')
                        worksheet.getCell('P32').alignment = { horizontal: 'center' }
                        worksheet.getCell('P32').font = { bold: true }
                        //for inbound table rows
                        for (let index = 0; index < response.inbound.length; index++) {
                            worksheet.getCell(`C${34 + index}`).value = response.inbound[index][0]
                            worksheet.mergeCells(`C${34 + index}:F${34 + index}`)
                            worksheet.getCell(`G${34 + index}`).value = response.inbound[index][1]
                            worksheet.mergeCells(`G${34 + index}:I${34 + index}`)
                        }
                        //for outbound table rows
                        for (let index = 0; index < response.outbound.length; index++) {
                            worksheet.getCell(`L${34 + index}`).value = response.outbound[index][0]
                            worksheet.mergeCells(`L${34 + index}:O${34 + index}`)
                            worksheet.getCell(`P${34 + index}`).value = response.outbound[index][1]
                            worksheet.mergeCells(`P${34 + index}:R${34 + index}`)
                        }
                        //for showing inbound volumes count
                        worksheet.getCell(`C${34 + response.inbound.length}`).value = "Total inbound volumes"
                        worksheet.mergeCells(`C${34 + response.inbound.length}:F${34 + response.inbound.length}`)
                        worksheet.getCell(`G${34 + response.inbound.length}`).value = this.inboundVolumeCount
                        worksheet.mergeCells(`G${34 + response.inbound.length}:I${34 + response.inbound.length}`)
                        worksheet.getCell(`C${34 + response.inbound.length}`).font = { bold: true }
                        worksheet.getCell(`G${34 + response.inbound.length}`).font = { bold: true }
                        //for showing outbound volumes count
                        worksheet.getCell(`L${34 + response.outbound.length}`).value = "Total outbound volumes"
                        worksheet.mergeCells(`L${34 + response.outbound.length}:O${34 + response.outbound.length}`)
                        worksheet.getCell(`P${34 + response.outbound.length}`).value = this.outboundVolumeCount
                        worksheet.mergeCells(`P${34 + response.outbound.length}:R${34 + response.outbound.length}`)
                        worksheet.getCell(`L${34 + response.outbound.length}`).font = { bold: true }
                        worksheet.getCell(`P${34 + response.outbound.length}`).font = { bold: true }
                        //for saving file
                        workbook.xlsx.writeBuffer().then((data: BlobPart) => {
                            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            FileSaver.saveAs(blob, "Warehouse_Volumes_Reports_" + this.datepipe.transform(date, "ddMMyyyy_HHmm","+0000"));
                            this.excelDisable=false;
                        })
                    });
                })
    }
    exportToPdf() {
        this.pdfDisable=true;
        var date = this.service.getDateByTZ()
        // this.dashboard = dashboard;
        this.dashboard.flag = "M";
        this.dashboard.downloadType = "pdf";
        let reqBody={...this.dashboard};
        reqBody.parentWarehouse=this.service.multiSelectValue(this.parentWarehousesArray,this.dashboard.parentWarehouse);
        reqBody.warehouse=this.service.multiSelectValue(this.warehousesArray,this.dashboard.warehouse);
        this.http
            .post(environment.apiUrl + "/dashboards/downloadWarehouseVolumes", reqBody, {
                headers: this.headers,
            })
            .subscribe(
                (response: any) => {
                    let PDF = new jsPDF('p', 'mm', 'a4');
                    html2canvas(this.inbound.nativeElement).then(canvasInbound => {
                        const inbound = canvasInbound.toDataURL();
                        html2canvas(this.outbound.nativeElement).then(canvasOutbound => {
                            const outbound = canvasOutbound.toDataURL();
                            PDF.setFontSize(18);
                            PDF.text(`Dashboard Pie Reports on : ${this.datepipe.transform(date, "short","+0000")}`, 48, 35);
                            PDF.addImage(inbound, 'PNG', 10, 45, 190, 100);
                            PDF.addImage(outbound, 'PNG', 10, 150, 190, 100);
                            PDF.addPage();
                             PDF.text(`Dashboard Inbound and Outbound Reports`, 48, 35);
                            PDF.setFontSize(14);
                            PDF.text("Inbound Reports", 40, 45);
                            (PDF as any).autoTable({
                                head: [['Warehouse Name', 'Inbound Doc Count']],
                                foot: [['Total inbound volumes', this.inboundVolumeCount]],
                                body: response.inbound,
                                theme: 'grid',
                                margin: { right: 90 },
                                startY: 50,
                                columnStyles: {
                                    0: {
                                        cellWidth: 50
                                    },
                                    1: {
                                        cellWidth: 30
                                    },
                                }
                            });
                            PDF.setPage(2);
                            PDF.text("Outbound Reports", 130, 45);
                            (PDF as any).autoTable({
                                head: [['Warehouse Name', 'Outbound Doc Count']],
                                foot: [['Total outbound volumes', this.outboundVolumeCount]],
                                body: response.outbound,
                                theme: 'grid',
                                margin: { left: 110 },
                                startY: 50,
                                columnStyles: {
                                    0: {
                                        cellWidth: 50
                                    },
                                    1: {
                                        cellWidth: 30
                                    },
                                }
                            })
                            PDF.save("TP_Volumes_Reports_" + this.datepipe.transform(date, "ddMMyyyy_HHmm","+0000"));
                            this.pdfDisable=false;
                        });
                    });
                },
                (error) => {
                    //console.log("Error occured" + error);
                    this.pdfDisable=false;
                }
            );
    }
}
